import React, { Component } from 'react';
import { Dropdown, DropdownMenu, DropdownItem } from 'reactstrap';
import { Link } from 'react-router-dom';

class Header extends Component {

	constructor(props) {
		super(props);

		this.toggle = this.toggle.bind(this);
		this.state = {
			dropdownOpen: false
		};
	}

	toggle() {
		this.setState({
			dropdownOpen: !this.state.dropdownOpen
		});
	}

	sidebarToggle(e) {
		e.preventDefault();
		document.body.classList.toggle('sidebar-hidden');
	}

	mobileSidebarToggle(e) {
		e.preventDefault();
		document.body.classList.toggle('sidebar-mobile-show');
	}

	asideToggle(e) {
		e.preventDefault();
		document.body.classList.toggle('aside-menu-hidden');
	}

	render() {
		return (
			<header className="app-header navbar no-print">
				<button className="navbar-toggler mobile-sidebar-toggler hidden-lg-up" onClick={this.mobileSidebarToggle} type="button">&#9776;</button>
				
				<Link to="/home" className="navbar-brand"> </Link>
				{/*<a className="navbar-brand" href="./home"></a>*/}

				<ul className="nav navbar-nav hidden-md-down b-l-1">
					<li className="nav-item">
						<Link to="/" className="nav-link navbar-toggler sidebar-toggler" onClick={this.sidebarToggle}>&#9776;</Link>
						{/*<a className="nav-link navbar-toggler sidebar-toggler" onClick={this.sidebarToggle} href="/">&#9776;</a>*/}
					</li>
				</ul>
{/*
				<form className="form-inline float-left b-r-1 px-2 hidden-md-down">
					<i className="fa fa-search"></i>
					<input className="form-control" type="text" placeholder="Search..."/>
				</form>
*/}
				<ul className="nav navbar-nav ml-auto">
{/*
					<li className="nav-item hidden-md-down">
						<a className="nav-link nav-pill" href="#"><i className="icon-bell"></i><span className="badge badge-pill badge-danger">5</span></a>
					</li>
					<li className="nav-item hidden-md-down">
						<a className="nav-link nav-pill" href="#"><i className="icon-list"></i></a>
					</li>
					<li className="nav-item hidden-md-down">
						<a className="nav-link nav-pill" href="#"><i className="icon-location-pin"></i></a>
					</li>
*/}
{/*
					<li className="nav-item dropdown">
						<Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggle}>
							<a onClick={this.toggle} className="nav-link nav-pill avatar" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded={this.state.dropdownOpen}>
								<img src={'img/statelo_ico_01a.png'} className="img-avatar" alt="admin@bootstrapmaster.com"/>
							</a>

							<DropdownMenu className="dropdown-menu-right">
								<DropdownItem header className="text-center"><strong>Account</strong></DropdownItem>

								<DropdownItem><i className="fa fa-bell-o"></i> Updates<span className="badge badge-info">42</span></DropdownItem>
								<DropdownItem><i className="fa fa-envelope-o"></i> Messages<span className="badge badge-success">42</span></DropdownItem>
								<DropdownItem><i className="fa fa-tasks"></i> Tasks<span className="badge badge-danger">42</span></DropdownItem>
								<DropdownItem><i className="fa fa-comments"></i> Comments<span className="badge badge-warning">42</span></DropdownItem>

								<DropdownItem header className="text-center"><strong>Settings</strong></DropdownItem>

								<DropdownItem><i className="fa fa-user"></i> Profile</DropdownItem>
								<DropdownItem><i className="fa fa-wrench"></i> Settings</DropdownItem>
								<DropdownItem><i className="fa fa-usd"></i> Payments<span className="badge badge-default">42</span></DropdownItem>
								<DropdownItem><i className="fa fa-file"></i> Projects<span className="badge badge-primary">42</span></DropdownItem>
								<DropdownItem divider />
								<DropdownItem><i className="fa fa-shield"></i> Lock Account</DropdownItem>
								<DropdownItem><i className="fa fa-lock"></i> Logout</DropdownItem>

							</DropdownMenu>
						</Dropdown>
					</li>
*/}
{/*					
					<li className="nav-item hidden-md-down">
						<a className="nav-link navbar-toggler aside-menu-toggler" onClick={this.asideToggle} href="#">&#9776;</a>
					</li>
*/}			
				</ul>
			</header>
		)
	}
}

export default Header;
